import { Button } from "@admin-ui/components/primitives/base/buttons/button";
import { cx } from "@admin-ui/utils/cx";
import { ArrowLeft, ArrowRight } from "@untitledui/icons";

export interface PaginationCardMinimalProps {
  page: number;
  total: number;
  onPageChange: (page: number) => void;
  align?: "left" | "right" | "center";
  className?: string;
}

export function PaginationCardMinimal({
  page,
  total,
  onPageChange,
  align = "right",
  className,
}: PaginationCardMinimalProps) {
  if (total <= 1) return null;

  const alignment =
    align === "right" ? "justify-end" : align === "center" ? "justify-center" : "justify-start";

  return (
    <div
      className={cx(
        "flex items-center gap-3 border-t border-secondary bg-primary",
        alignment,
        className,
      )}
    >
      <span className="text-sm font-medium text-secondary">
        Page {page} of {total}
      </span>
      <div className="flex gap-2">
        <Button
          size="sm"
          color="secondary"
          iconLeading={ArrowLeft}
          isDisabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </Button>
        <Button
          size="sm"
          color="secondary"
          iconTrailing={ArrowRight}
          isDisabled={page >= total}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
